enum LoadingState {
	None,
	Loading,
	Success,
	Fail
}

export default LoadingState
